import actionTypes from './actionTypes2';

const initialState = {
  combination: [],
  situation: [],
  highestCard: '',
  firstPairCardTableFold: [],
  secondPairCardTableFold: {},
  legenda: [],
  easyLegenda: [],
  doubleColor: false,
  easyDoubleColor: false,
  ts: '',
  bb: '',
  stake: '',
  card1: '',
  card2: '',
  card3: '',
  card4: '',
  suit: '',
  suitQuality: '',
  gameTable: '6max',
  ggps: 'ps',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.SET_TABLE_2}_SUCCESS`: {
      return {
        ...state,
        combination: action.payload.cardCombinations,
        highestCard: action.payload.highestCard,
      };
    }
    case `${actionTypes.SET_SITUATION_2}_SUCCESS`: {
      const {
        // eslint-disable-next-line no-unused-vars
        ts, situation, selectedBB, isTrial, isBBchanged, isGameTableChanged, gameTable, ggps,
      } = action.payload;

      const isPlo5 = sessionStorage.getItem('isPlo5') === 'true';
      const isBB = isTrial ? '50' : '100';

      const ggpsIsMtt = ggps === 'mtt';
      const ggpsIsHu = ggps === 'hu';

      const defineTs = () => {
        if (ggpsIsMtt) {
          if (isGameTableChanged) {
            return 'mttpot';
          }
          return ts;
        }

        if (ggpsIsHu) {
          return 'hu';
        }

        if (isGameTableChanged) {
          return 'low';
        }

        return ts;
      };

      return {
        ...state,
        situation,
        ts: defineTs(),
        // eslint-disable-next-line no-nested-ternary
        bb: (isPlo5 && selectedBB) ? (isBBchanged ? selectedBB : '100') : ((['mttpot', 'mtt2_25x', 'mttpot_ante', 'mttx25_ante'].includes(defineTs())) ? '50' : isBB),
        stake: '',
        card1: '',
        card2: '',
        gameTable,
      };
    }

    case `${actionTypes.SET_FIRST_PAIR_2}_SUCCESS`: {
      return {
        ...state,
        firstPairCardTableFold: action.payload.cells,
        purple: action.payload.purple,
      };
    }

    case `${actionTypes.SET_SECOND_PAIR_2}_SUCCESS`: {
      return {
        ...state,
        secondPairCardTableFold: action.payload.cells,
        purple: action.payload.purple,
      };
    }

    case actionTypes.SET_PURPLE_2: {
      return {
        ...state,
        purple: action.payload,
      };
    }

    case actionTypes.SET_TS_2: {
      const name = action.payload.toLowerCase().split(' ')[0];
      return {
        ...state,
        ts: name,
      };
    }
    case actionTypes.SET_BB_2: {
      return {
        ...state,
        bb: action.payload,
      };
    }
    case actionTypes.SET_GGPS_2: {
      return {
        ...state,
        ggps: action.payload,
      };
    }
    case actionTypes.SET_STAKE_2: {
      const stake = action.payload;
      return {
        ...state,
        stake,
      };
    }
    case actionTypes.SET_CARD1_2: {
      return {
        ...state,
        card1: action.payload,
      };
    }
    case actionTypes.SET_CARD2_2: {
      return {
        ...state,
        card2: action.payload,
      };
    }
    case actionTypes.SET_CARD3_2: {
      return {
        ...state,
        card3: action.payload,
      };
    }
    case actionTypes.SET_CARD4_2: {
      return {
        ...state,
        card4: action.payload,
      };
    }
    case actionTypes.SET_SUIT_2: {
      return {
        ...state,
        suit: action.payload,
      };
    }
    case actionTypes.SET_SUIT_QUALITY_2: {
      return {
        ...state,
        suitQuality: action.payload,
      };
    }

    case actionTypes.CLEAR_REDUCER: {
      return {
        ...state,
        combination: [],
        situation: [],
        firstPairCardTableFold: [],
        legenda: [],
        ts: '',
        bb: '',
        lowerTableBB: '',
        stake: '',
        card1: '',
        card2: '',
        doublesuit: false,
        rainbow: false,
      };
    }

    case `${actionTypes.SET_LEGENDA2}_SUCCESS`: {
      return {
        ...state,
        legenda: action.payload?.legenda || [],
        easyLegenda: action.payload?.easyLegenda || [],
        doubleColor: action.payload?.doubleColor || false,
        easyDoubleColor: action.payload?.easyDoubleColor || false,
      };
    }

    default: {
      return state;
    }
  }
};
